import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuthStore } from '../stores/authStore.js';

export function AdminRoute({ children }: { children: ReactNode }) {
  const user = useAuthStore((state) => state.user);
  // On a hard refresh, refreshAccessToken marks the session authenticated a
  // moment before /auth/me hydrates identity. Do not treat that short window
  // as a non-admin decision or a valid admin will be redirected away.
  if (!user) {
    return <div className="splash">Loading…</div>;
  }
  return user.role === 'ADMIN' ? <>{children}</> : <Navigate to="/dashboard" replace />;
}
